import { render, staticRenderFns } from "./Lembretes.vue?vue&type=template&id=5e38e9d3&"
import script from "./Lembretes.vue?vue&type=script&lang=js&"
export * from "./Lembretes.vue?vue&type=script&lang=js&"
import style0 from "./Lembretes.vue?vue&type=style&index=0&id=5e38e9d3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports